<style lang="less" scoped>
  #mobileOrderDetail {
    .area-container {
      .present-list-cover {
        padding: 12px;
        border-radius: 4px;
        background: #f8f8f8;
      }

      .buy-info-area {
        border: none;
        box-shadow: none;

        .buy-info {
          padding: 0;
        }

        .buy-result {
          display: none;
        }
      }
    }
  }

  .mobile-order-result-cover {
    display: flex;
    width: 100%;

    .mobile-order-info {
      flex: 1;
    }
  }
</style>

<template lang="pug">
  #mobileOrderDetail
    .area-container.area-container-mobile
      .present-list-cover
        ul
          li.list-title
            strong 처방 내역
          li 십전대보탕 (14ea, ￦420,000)
          li 십전대보탕 (14ea, ￦420,000)
          li 십전대보탕 (14ea, ￦420,000)
      sender-form-component
      .mobile.mobile-bottom-ui-cover
        .mobile-order-result-cover
          .mobile-order-info
            strong 총 142,200원
            div 십전대보탕 외 3건
          .mobile-order-btn-cover
            el-button(type="success" native-type="submit") 주문하기
</template>

<script>
import senderFormComponent from '@/components/sender_form';

export default {
  props: {
    title: {
      type: String,
    },
  },
  data() {
    return {
      page: {
        title: '새로운 주문',
        previous: false,
      },
      presents: [
        {
          name: '인삼',
          cost: 4200,
          cnt: 0,
        },
        {
          name: '홍삼',
          cost: 7900,
          cnt: 0,
        },
      ],
      cnt: 0,
      usepay: 1,
    };
  },
  components: {
    senderFormComponent,
  },
  mounted() {
    this.$store.commit('setTitle', this.title);
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/index/mobile_orders.vue